import { accommodationInventoryIdZodSchema } from "@@/shared/acquire/accommodation-inventory-id";
import { resourcePickerEnabledZodSchema } from "@@/shared/acquire/resource-references/resource-reference";
import { resourceIdZodSchema } from "@@/shared/acquire/resources/resource-id";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { productIdZodSchema } from "@@/shared/products/product-id";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import { z } from "zod";

const editInventoryCommandZodObject = z.object({
    _id: idZodSchema,
    _type: z.literal("EDIT_INVENTORY_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    productId: productIdZodSchema,
    providerId: providerIdZodSchema,
    inventoryId: accommodationInventoryIdZodSchema,

    resourceId: resourceIdZodSchema,
    pickerEnabled: resourcePickerEnabledZodSchema,
    displayResourceTitle: z.boolean(),
    title: translatableZodSchema.optional(),
    description: translatableZodSchema.optional(),

    paused: z.boolean(),
});

type EditInventoryCommand = z.infer<typeof editInventoryCommandZodObject>;

const editInventoryCommandFactoryParamsZodObject =
    editInventoryCommandZodObject.omit({
        _id: true,
        _type: true,
        _createdAt: true,
    });
type FactoryParams = z.infer<typeof editInventoryCommandFactoryParamsZodObject>;

const editInventoryCommandFactory = (params: FactoryParams) => {
    const EditInventoryCommand: EditInventoryCommand = {
        ...params,
        _id: generateId({ prefix: "add_Inventory_command__" }),
        _type: "EDIT_INVENTORY_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return EditInventoryCommand;
};

export {
    editInventoryCommandFactory,
    editInventoryCommandFactoryParamsZodObject,
    editInventoryCommandZodObject,
};
export type {
    EditInventoryCommand,
    FactoryParams as EditInventoryCommandFactoryParams,
};
